import { Button, Modal } from '@razorpay/blade/components';
import React, { PropsWithChildren } from 'react';
import ActionModal from '../components/ActionModal';

type Props = PropsWithChildren<{
  isOpen: boolean;
  onDismiss: () => void;
  componentName: string;
  onSubmit: () => void;
  isLoading?: boolean;
}>;

const DisableModal = ({
  componentName,
  isOpen,
  onDismiss,
  onSubmit,
  isLoading,
  children,
}: Props) => {
  return (
    <ActionModal
      isOpen={isOpen}
      onDismiss={onDismiss}
      headingText={`Disable ${componentName}?`}
      submitButton={
        <Button
          testID={`disable-component-button`}
          size={'medium'}
          onClick={onSubmit}
          color={'negative'}
          isLoading={isLoading}>
          Disable now
        </Button>
      }>
      {children}
    </ActionModal>
  );
};

export default DisableModal;
